export const DPA_LOG_SERVICE = 'lifesize.logdpa';
export const ACCOUNT_GET_DPA = 'logDPA/getAccountDpa';
export const ACCOUNT_SET_DPA = 'logDPA/setAccountDpa';
export const DPA_VERSION = '1.0';
